import type { FeatureFlag } from "../../lib/api/feature-flags";

export const ALL_GROUPS = "__all__";
export const UNGROUPED = "__ungrouped__";
const SEPARATOR = " › ";

export function topLevelGroup(flag: Pick<FeatureFlag, "groupName">): string {
  const name = flag.groupName?.trim();
  return name ? name.split(SEPARATOR)[0] : UNGROUPED;
}

export function groupTabValues(flags: FeatureFlag[]): string[] {
  const groups = [...new Set(flags.map(topLevelGroup))];
  const named = groups.filter((g) => g !== UNGROUPED).sort((a, b) => a.localeCompare(b));
  return groups.includes(UNGROUPED) ? [...named, UNGROUPED] : named;
}

export function filterAndSortFlags(
  flags: FeatureFlag[],
  { group, search, sortBy, order }: { group: string; search?: string; sortBy?: string; order?: "asc" | "desc" },
): FeatureFlag[] {
  const query = search?.trim().toLowerCase();
  const direction = order === "desc" ? -1 : 1;
  const sortValue = (f: FeatureFlag) =>
    sortBy === "group" ? (f.groupName ?? "￿") : sortBy === "key" ? f.key : f.label;
  return flags
    .filter((f) => group === ALL_GROUPS || topLevelGroup(f) === group)
    .filter(
      (f) =>
        !query ||
        f.label.toLowerCase().includes(query) ||
        f.key.toLowerCase().includes(query) ||
        (f.groupName ?? "").toLowerCase().includes(query),
    )
    .sort((a, b) => direction * sortValue(a).localeCompare(sortValue(b)) || a.label.localeCompare(b.label));
}
